import { createSlice, createAsyncThunk, type PayloadAction } from "@reduxjs/toolkit";
import axios from "@/features/axiosHelper";
import type { RootState } from "@/typedDispatch";

interface IUserStateSlice {
  userRole: string | null;
  status: string;
  error: string |null;
}

interface ISetUserRoleAction {
  userRole: string;
}

const userSlice = createSlice({
  name: "user",
  initialState: {
    userRole: null,
    status: "idle",
    error: null,
  } satisfies IUserStateSlice as IUserStateSlice,
  reducers: {
    setUserRole: (state, action: PayloadAction<ISetUserRoleAction>) => {
      const { userRole } = action.payload;
      state.userRole = userRole;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserRole.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchUserRole.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message ?? null;
      })
      .addCase(fetchUserRole.fulfilled, (state, action) => {
        state.status = "loaded";
        state.userRole = action.payload;
      });
  },
});

export const fetchUserRole = createAsyncThunk<string, void>(
  "operations/fetchUserRole",
  async () => {
    const response = await axios.get(`/account/user-profile`);
    return response.data.Role;
  },
);

export const selectUserRole = (state: RootState) => state.sessionInfo.user?.userRole;

export default userSlice.reducer;
